let color = {
	primary: "#2979ff",
	primaryDark: "#039a99",
	primaryDisabled: "#a0cfff",
	primaryLight: "#04e5e4",
	bgColor: "#f3f4f6",

	info: "#909399",
	infoDark: "#82848a",
	infoDisabled: "#c8c9cc",
	infoLight: "#f4f4f5",

	warning: "#ff9900",
	warningDark: "#f29100",
	warningDisabled: "#fcbd71",
	warningLight: "#fdf6ec",

	error: "#fa3534",
	errorDark: "#dd6161",
	errorDisabled: "#fab6b6",
	errorLight: "#fef0f0",

	success: "#19be6b",
	successDark: "#18b566",
	successDisabled: "#71d5a1",
	successLight: "#dbf1e1",

	mainColor: "#303133",
	contentColor: "#606266",
	tipsColor: "#909399",
	lightColor: "#c0c4cc",
	borderColor: "#e4e7ed"
}

export default color;
